import { ca } from '@cian/analytics';

const enum ETrackingFilterType {
  InitialPayment = 'initial_fee',
  LoanTerm = 'mortgage_term',
}

export const trackInitialPaymentFilterChange = () => trackFilterChange(ETrackingFilterType.InitialPayment);
export const trackLoanTermFilterChange = () => trackFilterChange(ETrackingFilterType.LoanTerm);

function trackFilterChange(filterType: ETrackingFilterType) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Promo',
    label: filterType,
    name: 'oldevent',
    useLastProducts: true,
  });
}
